import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-302de826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrapper" }
const _hoisted_2 = { class: "df mt-15" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "case-wrapper__item" }
const _hoisted_6 = {
  key: 0,
  class: "case--info"
}
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "selector" }
const _hoisted_9 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "checker unchecked"
}
const _hoisted_13 = {
  key: 0,
  class: "title-search"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_message_share_settings = _resolveComponent("app-message-share-settings")!
  const _component_item_case = _resolveComponent("item-case")!
  const _component_app_skeleton_case = _resolveComponent("app-skeleton-case")!
  const _component_app_case_view_pop_up = _resolveComponent("app-case-view-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, {
      customTitle: _ctx.title,
      "count-padding": ""
    }, {
      bottom: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_search, {
              modelValue: _ctx.driveStore.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driveStore.search) = $event)),
              onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.search = ''))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["mrl-16 icon", _ctx.driveStore.isGridCasesView ? 'icon-tiles-2' : 'icon-list-view']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.driveStore.isGridCasesView = !_ctx.driveStore.isGridCasesView))
          }, null, 2)
        ])
      ]),
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["prevent"])),
          class: "back-link"
        }, _toDisplayString(_ctx.$localize('message.case.selector.cancel.button')), 1)
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doneAction && _ctx.doneAction(...args)), ["prevent"])),
          class: _normalizeClass([{ disabled: !_ctx.selectedList.length }, "back-link"])
        }, _toDisplayString(_ctx.$localize('message.case.selector.done.button')), 3)
      ]),
      _: 1
    }, 8, ["customTitle"]),
    _createVNode(_component_app_message_share_settings, {
      "share-settings": _ctx.shareSettings,
      onUpdateSettings: _ctx.updateShareSettings
    }, null, 8, ["share-settings", "onUpdateSettings"]),
    _createElementVNode("div", {
      ref: "scroller",
      onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      class: _normalizeClass(["case-wrapper scroll", {'case-wrapper--grid': _ctx.driveStore.isGridCasesView}])
    }, [
      (!_ctx.dataLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (iCase) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "df case-wrapper__item-wrap",
                key: iCase.id!,
                onClick: ($event: any) => (_ctx.selectCase(iCase.id!))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_item_case, {
                    iCase: iCase,
                    hideTitle: !_ctx.driveStore.isGridCasesView,
                    onClick: ($event: any) => (_ctx.setPreviewCase($event, iCase))
                  }, null, 8, ["iCase", "hideTitle", "onClick"])
                ]),
                (!_ctx.driveStore.isGridCasesView)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("h5", _hoisted_7, _toDisplayString(iCase.title), 1),
                      _createElementVNode("p", null, _toDisplayString(iCase.description || 'There is no case description yet'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.caseCheck[iCase.id!])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12))
                ])
              ], 8, _hoisted_4))
            }), 128)),
            (!_ctx.cases.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " No search results found. "))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.dataLoading || _ctx.isPageLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(21, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "skeleton-wrapper"
            }, [
              _createVNode(_component_app_skeleton_case, {
                columnView: !_ctx.driveStore.isGridCasesView
              }, null, 8, ["columnView"])
            ])
          }), 64))
        : _createCommentVNode("", true)
    ], 34),
    (_ctx.previewCase.show)
      ? (_openBlock(), _createBlock(_component_app_case_view_pop_up, {
          key: 0,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.previewCase.show = false)),
          onDone: _ctx.selectCase,
          caseId: _ctx.previewCase.id,
          title: _ctx.previewCase.title,
          "photo-skeletons": _ctx.previewCase.photosAmount,
          "file-skeletons": _ctx.previewCase.filesAmount,
          selector: ""
        }, null, 8, ["onDone", "caseId", "title", "photo-skeletons", "file-skeletons"]))
      : _createCommentVNode("", true)
  ]))
}